import { tryLoadAndStartRecorder } from '@alwaysmeticulous/recorder-loader';

import { initializeSentry } from './utils/sentry';

export async function initializeApp() {
  // Initialize Sentry as early as possible
  initializeSentry();

  // Initialize meticulous recorder if needed
  const isStaging = import.meta.env.MODE === 'staging';
  const isDev = import.meta.env.MODE === 'development';
  const isEx4InUrl = window.location.pathname.includes('/ex4/');

  if (isStaging || (isDev && isEx4InUrl)) {
    await tryLoadAndStartRecorder({
      projectId: 'yPFLCsjto5ajtqvKMnAbfwQJd8SCWNPT4eUxKpSi',
    });
  }
}
